module.exports = __webpack_public_path__ + "img/owl-minified.509d2dc2.svg";